
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotificationFilled as ObiNotificationFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-notification-filled.js';
 
 
 

 
 export const ObiNotificationFilled = createComponent({
   react: React,
   tagName: 'obi-notification-filled',
   elementClass: ObiNotificationFilledElement,
   events: {
     
   }
  });
 
 